// ./frontend/src/reducers/agencyReducer.js
import { SET_DOCKET_DATA,SET_DOCKET_STATUS,RESET_DOCKET_DATA } from "../config";

const INITIAL_STATE={
  docketList:{
  },
  docketStatus:"open"
}
export function docketReducer(state = INITIAL_STATE, action) {
  switch(action.type) {
    case SET_DOCKET_DATA:
      state = {...state, docketData:action.docketList};
      return state;
	case SET_DOCKET_STATUS:
      state = {...state, docketStatus:action.status};
      return state;
	  case RESET_DOCKET_DATA:
      return INITIAL_STATE;
    default:
      return state;
  }
}